import { createFileRoute } from '@tanstack/react-router';
import { match } from 'ts-pattern';
import { z } from 'zod/v4';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { getRegistrationProfileCreatePath } from '../../../../../../../../features/registration/profile/registration-profile-routing';
import { getPageHead } from '../../../../../../../../util/routing/meta';

const pathParamsSchema = z.object({
  profileType: z.enum(['individual', 'organization']),
});

export const Route = createFileRoute('/_app/_clearing-core/registration/profile/_profile/create/$profileType/_create')({
  params: {
    parse: (values) => {
      const parsed = pathParamsSchema.safeParse(values);
      if (!parsed.success) {
        return { profileType: 'individual' } as const;
      }

      return parsed.data;
    },
  },
  loader: ({ params }) =>
    ({
      breadcrumb: buildBreadcrumb({
        id: `create-profile-${params.profileType}`,
        label: match(params.profileType)
          .with('organization', () => 'New Organization')
          .otherwise(() => 'New Individual'),
        to: getRegistrationProfileCreatePath(params.profileType),
      }),
    }) satisfies AggregateBreadcrumb,
  head: () => getPageHead('Create Profile'),
});
